import React from "react";
import { SectionHeading } from "./SectionHeading";
import { VolumeCard } from "./VolumeCard";
import { volumes } from "../../data/volumes";
export function Volumes() {
  return <section className="w-full border-t border-navy/10 bg-white px-5 py-14 md:py-20" data-id="element-289" data-mp="3abwscxvz5f1p">
      <div className="mx-auto max-w-5xl" data-id="element-290" data-mp="3a9tvbtwemlnh">
        <SectionHeading title="The complete 5-volume prenatal training system" data-id="element-291" data-mp="35e4px9xpeaj9" />

        <div className="mt-6 text-center" data-id="element-292" data-mp="6vzf2g2inqz5">
          <p className="font-display text-xl font-black uppercase text-navy md:text-2xl" data-id="element-293" data-mp="6uocukopyra5">Prenatal Training Pro 2026</p>
          <p className="mt-1 text-base font-semibold text-navy/75" data-id="element-294" data-mp="1ujtmmwffig8">Ready-to-Coach Training for Fitness Professionals</p>
          <p className="mt-3 text-sm font-semibold text-navy/80" data-id="element-295" data-mp="3p1cfm3war2cn">Assessment • Weeks 1–40 • Strength • RPE • Progressions • Modifications</p>
        </div>

        <h3 className="mt-12 text-center font-display text-lg font-black uppercase tracking-[0.08em] text-navy md:text-xl" data-id="element-296" data-mp="2hp28o36zejpa">What’s included</h3>
        <div className="mt-6 space-y-4" data-id="element-297" data-mp="f85f3qivxqeo">
          {volumes.map(v => <VolumeCard key={v.number} volume={v} data-id="element-298" data-mp="f8ox178jcesp" />)}
        </div>
      </div>
    </section>;
}